import { queryOptions } from "@tanstack/react-query";
import { profilePageSchema, rosterResponseSchema } from "@amber/application/contracts";
import { profileKeys } from "@amber/profiles/ui";
import { POLL_MS, apiGet } from "@amber/ui";

export const rosterQuery = queryOptions({
  queryKey: profileKeys.roster,
  queryFn: ({ signal }) => apiGet("/api/profiles/roster", rosterResponseSchema, signal),
  refetchInterval: POLL_MS,
});

export const profileQuery = (id: string) =>
  queryOptions({
    queryKey: profileKeys.detail(id),
    queryFn: ({ signal }) => apiGet(`/api/profiles/${encodeURIComponent(id)}`, profilePageSchema, signal),
    refetchInterval: POLL_MS,
  });
